module.exports = __webpack_public_path__ + "img/f33e908.jpg";